module.exports = __webpack_public_path__ + "img/twitter.456e852b.png";